import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "b",
	"data-name": "Layer 2",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 832.57 1665.17",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "c",
		"data-name": "Layer 1",
		children: /* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				d: "m832.57,0L0,832.59l832.57,832.59v-237.88L237.87,832.59,832.57,237.88V0Z",
				style: {
					fill: "currentColor",
					strokeWidth: 0
				}
			}),
			/* @__PURE__ */ _jsx("polygon", {
				points: "832.57 594.71 594.71 832.59 832.57 1070.47 832.57 1308.35 356.81 832.59 832.57 356.82 832.57 594.71",
				style: {
					fill: "currentColor",
					strokeWidth: 0
				}
			}),
			/* @__PURE__ */ _jsx("polygon", {
				points: "356.81 832.59 832.57 356.82 832.57 594.71 594.71 832.59 832.57 1070.47 832.57 1308.35 356.81 832.59",
				style: {
					fill: "currentColor",
					strokeWidth: 0
				}
			}),
			/* @__PURE__ */ _jsx("polygon", {
				points: "832.57 0 832.57 237.88 237.87 832.59 832.57 1427.29 832.57 1665.17 0 832.59 832.57 0",
				style: {
					fill: "currentColor",
					strokeWidth: 0
				}
			})
		] })
	})
});
export default SvgArrow;
